<style lang="scss">





.card-title {
  font-size: 1.94rem;
  font-family:  'PingFang SC','Microsoft YaHei';
  font-weight: bold;
  color: #4b4b4b;
  margin-top: 2rem;
}
.card-subtitle {
  font-size: 1rem;
  font-family:  'PingFang SC','Microsoft YaHei';
  font-weight: 500;
  color: #e5004f;
  margin-top: -2rem;
  margin-bottom: 2rem;
}
.card-content {
  font-size: 1.18rem;
  font-family:  'PingFang SC','Microsoft YaHei';
  font-weight: 400;
  color: #7f7f7f;
  line-height: 1.94rem;
}
.card-content-title {
  font-size: 1.8rem;
  font-family:  'PingFang SC','Microsoft YaHei';
  font-weight: 400;
  color: #7f7f7f;
  line-height: 1.94rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

@media screen and (min-width: 55rem) {
  .content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;

    .joincontact {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .joincontact-left {
        width: 50%;
        display: flex;
        flex-direction: column;
        .new-contact-1 {
          width: 100%;
          height: 50rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #cdcacabe;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          .new-contact-1-top {
            width: 100%;
            height: 22rem;
            background-size: 100% 100%;
            background-image: url("/media/yintai/contact-1.png");
            // margin-left: -1rem;
          }
          .new-contact-1-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
        .new-contact-2 {
          margin-top: 4rem;
          width: 100%;
          height: 52rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #cdcacabe;
          display: flex;
          flex-direction: column;
          align-items: center;
          .new-contact-2-top {
            width: 100%;
            height: 22rem;
            background-size: 100% 100%;
            background-image: url("/media/yintai/contact-2.png");
            // margin-left: -1rem;
          }
          .new-contact-2-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
      }
      .joincontact-right {
        width: 45%;
        display: flex;
        flex-direction: column;
        .new-contact-3 {
          width: 100%;
          height: 85rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #cdcacabe;
          display: flex;
          flex-direction: column;
          align-items: center;
          .new-contact-3-top {
            width: 100%;
            height: 22rem;
            background-size: 100% 100%;
            background-image: url("/media/yintai/contact-3.png");
            // margin-left: -1rem;
          }
          .new-contact-3-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
        .new-contact-4 {
          margin-top: 1rem;
          width: 100%;
          height: 20rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #cdcacabe;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .new-contact-4-top {
            width: 80%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-around;
            .qrcode {
              width: 16rem;
              height: 16rem;
              background-image: url("/media/yintai/qrcode4.png");
              background-size: 100% 100%;
            }
          }
          .new-contact-4-bottom {
            width: 80%;
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #7f7f7f;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;

    .joincontact {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .joincontact-left {
        width: 100%;
        display: flex;
        flex-direction: column;
        .new-contact-1 {
          width: 100%;
          height: 50rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #cdcacabe;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          .new-contact-1-top {
            width: 100%;
            height: 22rem;
            background-size: 100% 100%;
            background-image: url("/media/yintai/contact-1.png");
            // margin-left: -1rem;
          }
          .new-contact-1-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
        .new-contact-2 {
          margin-top: 4rem;
          width: 100%;
          height: 52rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #cdcacabe;
          display: flex;
          flex-direction: column;
          align-items: center;
          .new-contact-2-top {
            width: 100%;
            height: 22rem;
            background-size: 100% 100%;
            background-image: url("/media/yintai/contact-2.png");
            // margin-left: -1rem;
          }
          .new-contact-2-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
      }
      .joincontact-right {
        margin-top: 5rem;
        width: 100%;
        display: flex;
        flex-direction: column;
        .new-contact-3 {
          width: 100%;
          height: 85rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #cdcacabe;
          display: flex;
          flex-direction: column;
          align-items: center;
          .new-contact-3-top {
            width: 100%;
            height: 22rem;
            background-size: 100% 100%;
            background-image: url("/media/yintai/contact-3.png");
            // margin-left: -1rem;
          }
          .new-contact-3-bottom {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            text-align: center;
          }
        }
        .new-contact-4 {
          margin-top: 1rem;
          width: 100%;
          height: 25rem;
          border-radius: 1.2rem;
          box-shadow: 0px 3px 5px #cdcacabe;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .new-contact-4-top {
            width: 80%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .qrcode {
              width: 16rem;
              height: 16rem;
              background-image: url("/media/yintai/qrcode4.png");
              background-size: 100% 100%;
            }
            .button-right {
              margin-top: 1rem;
              margin-bottom: 1rem;
            }
          }
          .new-contact-4-bottom {
            width: 80%;
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #7f7f7f;
          }
        }
      }
    }
  }
}
</style>


<script>
import ButtonRight from "@/yintai/view/component/ButtonRight";

export default {
  name: "newsContent",
  components: { ButtonRight },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
